import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Get the list view type for the Group
 */
export default function getListViewTypeForGroup(): ReactListViewType {
    // If value not set, return Conversation type.
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (12,37): Object is possibly 'undefined'.
    // @ts-expect-error
    const globalListViewTypeReact = getUserConfiguration().UserOptions.GlobalListViewTypeReact;
    if (globalListViewTypeReact == undefined) {
        return ReactListViewType.Conversation;
    }

    // Otherwise returns the GlobalListViewTypeReact in user options
    return globalListViewTypeReact;
}
